import React, { useEffect, useState } from "react";
import { Text, Box, Flex, HStack, IconButton, Stack, useDisclosure } from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { Link } from "react-scroll";

// [display label, section id]
const links = [
  ["Home", "Home"],
  ["Origin", "About"],
  ["Education", "Education"],
  ["Journey", "Work Experiance"],
  ["Skills", "Skill's"],
  ["Work", "Projects"],
  ["Words", "Words"],
  ["Contact", "Contact"],
];

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkStyle = {
    color: "#c2c9d6",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: "13px",
    letterSpacing: "0.03em",
  };

  return (
    <Box
      as="header"
      position="fixed"
      top="0"
      left="0"
      w="100%"
      zIndex="1000"
      px={{ base: "6%", md: "8%" }}
      bg={scrolled ? "rgba(15,22,36,0.75)" : "transparent"}
      backdropFilter={scrolled ? "blur(12px)" : "none"}
      borderBottom={scrolled ? "1px solid rgba(96,165,250,0.15)" : "1px solid transparent"}
      transition="all 0.3s ease"
    >
      <Flex h="62px" alignItems="center">
        {/* brand */}
        <Link to="Home" smooth duration={500} style={{ cursor: "pointer" }}>
          <Text fontWeight="900" fontSize="lg" color="#f0f2f7" letterSpacing="0.02em">
            Mukul<Box as="span" color="#60A5FA">.</Box>
          </Text>
        </Link>

        <Box flex="1" />

        {/* desktop nav */}
        <HStack as="nav" spacing={7} display={{ base: "none", md: "flex" }}>
          {links.map(([label, id]) => (
            <Link
              key={id}
              to={id}
              spy
              smooth
              offset={-70}
              duration={500}
              activeClass="nav-active"
              style={linkStyle}
            >
              <Text
                _hover={{ color: "#60A5FA" }}
                transition="all 0.25s"
                textTransform="uppercase"
              >
                {label}
              </Text>
            </Link>
          ))}
        </HStack>

        {/* mobile toggle */}
        <IconButton
          size="md"
          bg="#60A5FA"
          color="white"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Open menu"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
          _hover={{ bg: "#3B82F6" }}
        />
      </Flex>

      {/* mobile menu */}
      {isOpen && (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={3}>
            {links.map(([label, id]) => (
              <Link
                key={id}
                to={id}
                spy
                smooth
                offset={-70}
                duration={500}
                onClick={onClose}
                style={linkStyle}
              >
                <Text _hover={{ color: "#60A5FA" }} py="4px">
                  {label}
                </Text>
              </Link>
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
}
